<awair-floor-plan-editor-header [isFloorPlanEdited]="isFloorPlanEdited$ | async"
                                [hasSelectedFloor]="(selectedFloor$ | async) != null ? true : false"
                                (close)="onClose($event)">
</awair-floor-plan-editor-header>

<section class="__body">
  <awair-floor-plan-editor-top class="__top"></awair-floor-plan-editor-top>

  <div class="__body-group">
    <awair-floor-plan-editor-sidebar class="__sidebar">
    </awair-floor-plan-editor-sidebar>

    <awair-floor-plan-editor-main class="__main"></awair-floor-plan-editor-main>
  </div>
</section>
